import { render } from "./SwdDialogSucces.vue?vue&type=template&id=ed425ba4"
import script from "./SwdDialogSucces.vue?vue&type=script&lang=js"
export * from "./SwdDialogSucces.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__